module.exports = __webpack_public_path__ + "img/regionalCase_bg_6.06bd1b00.jpg";